import checkmysite from "./checkMySite/index";

(function () {
  if (document.getElementById('crftd-cms-form')) {
    checkmysite.initialize();
  }

})();
